(function(){
"use strict";
/* Un tocco solo, sempre: la linguetta accende e spegne la radio senza
   passaggi intermedi. Se sta suonando, il primo tocco la ferma — anche
   mentre si scorre. Il ritiro durante lo scorrimento serve solo a non
   coprire il testo, non deve mai rendere il tasto difficile da colpire. */
var barra = document.getElementById("dradio");
var tasto = document.getElementById("drTasto");
if(!barra || !tasto) return;

var tFermo = null;

/* mentre si scorre si ritira; appena ci si ferma torna */
addEventListener("scroll", function(){
 barra.classList.add("viascorre");
 clearTimeout(tFermo);
 tFermo = setTimeout(function(){ barra.classList.remove("viascorre"); }, 650);
}, {passive:true});

/* un tocco in qualunque punto della linguetta comanda la radio */
barra.addEventListener("click", function(e){
 if(e.target.closest("#drTasto")) return;   /* ci pensa gia' il tasto */
 e.preventDefault();
 barra.classList.remove("viascorre");
 tasto.click();
});

/* toccandola smette di nascondersi per un attimo, cosi' si vede
   subito se è partita o si è fermata */
barra.addEventListener("pointerdown", function(){
 barra.classList.remove("viascorre");
 clearTimeout(tFermo);
});

/* quando entra un messaggio si affaccia un attimo */
var stato = document.getElementById("drStato");
if(stato && window.MutationObserver){
 new MutationObserver(function(){
  if(stato.textContent.indexOf("onda") === -1) return;
  barra.classList.remove("viascorre");
 }).observe(stato, {childList:true, characterData:true, subtree:true});
}
})();
